import { Tab } from "@mui/material";
import classNames from "classnames";
import React, { FC } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  height?: number;
  className?: string;
}
export function TabPanel(props: TabPanelProps) {
  const { height, className, children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className={className}
      style={{ height, overflowY: height ? "auto" : undefined }}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
